// Page entry for PRD 05 (문항 설계 / Questionnaire Design).
//
// Permission model (PRD 05 §1.2):
//   - PRO_MGMT:READ → view-only access (allowed here; write controls hidden).
//   - PRO_MGMT:WRITE / Root → full CRUD.
//   - PRO_MGMT:NO_PERMISSION (seed SYSTEM) → LNB still shows the menu (PRD 21
//     §4.5), entry is blocked here with the 권한 없음 modal.

import { useTranslation } from 'react-i18next';

import { QuestionnaireDesignView } from '@/features/questionnaire-design/components/QuestionnaireDesignView';
import { useRequirePermission } from '@/shared/hooks/useRequirePermission';

export function QuestionnaireDesignPage() {
  const { t } = useTranslation('questionnaire-design');
  // SHCT-171 — was a private in-page card. PRD 21 §7.2 specifies 권한 없음 as a 모달 with
  // "접근 권한이 없습니다.", so every gated page now blocks the same way through this hook.
  const canRead = useRequirePermission('PRO_MGMT', 'READ');

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('page.title')}</h1>
        </div>
      </div>
      <div className="content__body">
        <QuestionnaireDesignView />
      </div>
    </>
  );
}
